<template>
  <section class="rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-4 sm:p-6" @invalid.capture="expanded = true">
    <h2 class="mb-4 text-base font-semibold text-[var(--color-text)]">
      <button
        v-if="collapsible"
        type="button"
        class="flex w-full items-center justify-between gap-3 text-left rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4"
        :aria-expanded="expanded"
        :aria-controls="contentId"
        @click="expanded = !expanded"
      >
        {{ title }}
        <span aria-hidden="true" class="text-[var(--color-muted)]">{{ expanded ? '−' : '+' }}</span>
      </button>
      <template v-else>{{ title }}</template>
    </h2>
    <div :id="contentId" v-show="!collapsible || expanded">
      <slot />
    </div>
  </section>
</template>

<script setup>
import { ref, useId } from 'vue'

defineProps({
  title: { type: String, required: true },
  collapsible: { type: Boolean, default: false },
})
const expanded = ref(false)
const contentId = useId()
</script>
